<template>
  <div class="module-container">
    <div class="container">
      <div class="module-header">
        <div class="module-title">为什么选择易隆创？</div>
      </div>

      <div class="decision-cards">
        <!-- 第一个卡片 -->
        <div class="decision-card">
          <div class="card-icon">
            <img class="card-icon-iamge" src="@/assets/img/home/Decision/icon_bq.png">
          </div>
          <div class="card-content">
            <div class="card-title">
              <div class="title-line">你有的，帮你<span class="highlight-orange">放大</span>；</div>
              <div class="title-line">你没有的，生态给你<span class="highlight-orange">补全</span></div>
            </div>
            <div class="card-description">
              以前是你一个人扛所有，现在是整个生态帮你变现
            </div>
          </div>
        </div>

        <!-- 第二个卡片 -->
        <div class="decision-card">
          <div class="card-icon">
            <img class="card-icon-iamge" src="@/assets/img/home/Decision/icon_dd.png">
          </div>
          <div class="card-content">
            <div class="card-title">
              <div class="title-line">缺人、缺钱、缺技术、缺资质，</div>
              <div class="title-line">平台替你<span class="highlight-orange">兜底</span></div>
            </div>
            <div class="card-description">
              以前是有单不敢接，现在是只要敢想，生态就敢陪你干
            </div>
          </div>
        </div>

        <!-- 第三个卡片 -->
        <div class="decision-card">
          <div class="card-icon">
            <img class="card-icon-iamge" src="@/assets/img/home/Decision/icon_zd.png">
          </div>
          <div class="card-content">
            <div class="card-title">
              <div class="title-line">你帮生态赚钱</div>
              <div class="title-line">生态帮你<span class="highlight-orange">做大</span></div>
            </div>
            <div class="card-description">
              以前是一锤子买卖，赚一笔是一笔；现在是生态复利越滚越大
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
};
</script>

<style lang="less" scoped>
.module-container {
  padding: 64px 0;
  background-color: #fff;

  .container {
    max-width: @content-width;
    margin: 0 auto;
    padding: 0 20px;
  }

  .module-header {
    text-align: center;
    margin-bottom: 64px;

    .module-title {
      font-size: 32px;
      font-weight: 600;
      color: #333;
    }
  }

  .decision-cards {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
  }

  .decision-card {
    background-color: #fff;
    border-radius: 12px;
    padding: 32px;
    box-shadow: 0 4px 32px rgba(0, 0, 0, 0.08);
    transition: transform 0.3s ease;

    &:hover {
      transform: translateY(-8px);
    }

    .card-icon {
      margin-bottom: 24px;
      width: 56px;
      height: 56px;
      background-color: #F5F7F8;
      border-radius: 50%;
      display: flex;
      justify-content: center;
      align-items: center;

      .card-icon-iamge {
        width: 32px;
        height: 32px;
      }
    }

    .card-content {
      .card-title {
        margin-bottom: 16px;

        .title-line {
          font-size: 18px;
          font-weight: 600;
          color: #333;
          line-height: 1.6;

          .highlight-orange {
            color: #FF8201;
          }
        }
      }

      .card-description {
        font-size: 15px;
        color: #666;
        line-height: 1.6;
      }
    }
  }
}
</style>
